import React from 'react';
import { Dialog } from '@mui/material';
import ConfirmButton from 'components/buttons/Confirm';
import CardActions from 'components/Card/Actions';
import CardHeader from 'components/Card/Header';
import CardText from 'components/Card/Text';
import Card from 'components/Card';
import PropTypes from 'prop-types';

const SponsorMessage = ({
  open,
  message = `We couldn't find the brand you're looking for. Don't worry, explore a
variety of amazing brands on our list!`,
  onClick,
}) => {
  return (
    <Dialog fullWidth modal open={open}>
      <Card>
        <CardHeader
          titleStyle={{ fontSize: '1rem !important' }}
          title='Oops!'
        />
        <CardText noTopPadding>{message}</CardText>
        <CardActions
          style={{ justifyContent: 'center', marginTop: '1rem' }}
          noTopPadding
        >
          <ConfirmButton label='Okay' primary onClick={onClick} />
        </CardActions>
      </Card>
    </Dialog>
  );
};

SponsorMessage.propTypes = {
  open: PropTypes.bool.isRequired,
  message: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default SponsorMessage;
